import React from 'react';
import { conf as globalConf } from 'apps/config.yaml';
import { imageSrc } from 'apps/file/utils';
import { ImageWrapper } from 'apps/share/blocks/shareCard.styles';
import { viewerURLtoPreviewer } from 'libs/rendering/utils';

const { imageDefaults, imgSizes } = globalConf;

function imageFromFile(file) {
  const hasPreview = file?.conversionGltfjson?.status === 'SUCCESS';
  return {
    completed: false,
    src: hasPreview
      ? viewerURLtoPreviewer(file?.viewerPath, {
          thumbnail: true,
        })
      : `/thumb/${file.id}`,
  };
}

export function CadPreview(file) {
  return (
    <ImageWrapper noBorder>
      <img
        src={imageSrc(
          imageFromFile(file),
          imageDefaults.file,
          imgSizes.project?.card,
        )}
        alt='CAD model thumbnail'
      />
    </ImageWrapper>
  );
}
